import { adminHref } from "../adminPath";

/**
 * In-CRM destinations, re-rooted onto the current console base (admin/adminPath.js), so a
 * link written once works under `/admin/crm/...` and `/t/{slug}/admin/crm/...` alike and
 * never depends on which CRM route it is rendered from (a relative "clients/x" from the
 * Clients route would resolve to ".../clients/clients/x").
 */
export const crmHref = (path = "") => adminHref(`/admin/crm${path}`);

export const clientHref = (id, query = "") => crmHref(`/clients/${encodeURIComponent(id)}${query ? `?${query}` : ""}`);
